import { useEffect, useState } from 'react';
import {
  fetchCateringCartAPI,
  deleteCateringCartItemAPI,
  editCateringToCartAPI,
  refundcateringfromcartapi,
} from '../Apiservices/Auth/cart/Addtocart_api';
import { useDispatch } from 'react-redux';
import { addServiceToCart, removeCateringServiceByMappingId, removeCateringServicesByProviderId } from '../store/cartbodydataslice';

export const useCateringCart = () => {
  const [cateringCartData, setCateringCartData] = useState([]);
  const [cateringCartLoading, setCateringCartLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchCateringCart = async () => {
      setCateringCartLoading(true);
      try {
        const response = await fetchCateringCartAPI();

        setCateringCartData(response?.data || []);
        // console.log("cateringdata",response.data.data)
        response.data.data.forEach((cartitem) => {
          const eveId = cartitem.event_id;
          const eventname = cartitem.event_title;
          const event_start_date = cartitem.event_start_date
          cartitem.catering_providers.forEach((cateringitem) => {
            const dispatchPayload = {
              eveId,
              eventname: eventname,
              event_start_date: event_start_date,
              type: "cateringData",
              item: {
                ...cateringitem,
                provider_id: cateringitem.provider_id,
                balance_to_be_paid: cateringitem.balance_to_be_paid,
                is_checked_out: cateringitem.is_checked_out,
                is_edit_allowed: cateringitem.is_edit_allowed,
                paid_amount: cateringitem.paid_amount,
                providername: `${cateringitem.first_name} ${cateringitem.last_name}`,
                services: cateringitem.items.map((item) => ({
                  ...item,
                  mapping_id: item.item_id,
                  service_id: item.category_id,
                  quantity: item.number_of_people,
                  price: item.regular_price,
                  discountPrice: item.discounted_price,
                  gst_amount: item.gst_amount,
                  gst_percentage: item.gst_percentage,
                  total_amount: item.total_amount,
                  validUpto: item.valid_until,
                  category: item.category.name,
                  mealtype: item.meal.name,
                  cuisine: item.type.name,
                })),
              },
            };

            try {
              dispatch(addServiceToCart(dispatchPayload));
            } catch (dispatchErr) {
              console.error("Dispatch Error (addServiceToCart):", dispatchErr);
              console.log("Failed Dispatch Payload:", dispatchPayload);
            }
          });
        });
      } catch (err) {
        console.error('Error loading catering cart:', err);
        setCateringCartData([]);
      }
      setCateringCartLoading(false);
    };

    fetchCateringCart();
  }, [refreshTrigger]);

  const refreshCateringCart = () => setRefreshTrigger((prev) => prev + 1);

  const transformUpdatedItems = (updatedItems) => {
    if (updatedItems.length === 0) return null;

    const { event_id, provider_id } = updatedItems[0];
    const items = updatedItems.map((item) => ({
      mapping_id: item.mapping_id,
      number_of_people: item.number_of_people,
    }));

    return {
      event_id,
      provider_id,
      items,
    };
  };
  const editCateringItems = async (eventId, providerId, updatedItems) => {
    try {
      const formattedPayload = transformUpdatedItems(updatedItems);

      if (!formattedPayload) {
        return { success: false, message: "No items to update" };
      }

      const { event_id, provider_id, items } = formattedPayload;
      console.log(event_id, provider_id, items)
      // Call API to update catering cart items
      const result = await editCateringToCartAPI({ event_id, provider_id, items });

      // console.log("Updated Catering Cart:", result);

      // Refresh cart after successful update
      refreshCateringCart();

      return { success: true, message: "Catering cart updated" };
    } catch (err) {
      console.error("Edit catering error:", err);
      return { success: false, message: "Failed to update catering cart" };
    }
  };


  const removeCateringProvider = async (event_id, provider_id, mappingId) => {
    try {

      console.log("delete", event_id, provider_id);
      await deleteCateringCartItemAPI(event_id, provider_id);
      // dispatch(removeCateringServiceByMappingId({
      //     eventId: event_id,
      //     providerId: provider_id,
      //     mappingId: mappingId
      //   }));
      dispatch(removeCateringServicesByProviderId({
        eventId: event_id,
        providerId: provider_id
      }));
      refreshCateringCart();
    } catch (error) {
      console.error("Error removing catering cart item:", error);
    }
  };

  const refundcateringfromcart = async (event_id, provider_id) => {
    try {
      const response = await refundcateringfromcartapi(event_id, provider_id);
      return response;
    } catch (error) {
      console.error("Refund Priest from cart error:", error.message);
      throw error;
    }
  };

 

  return {
    cateringCartData,
    cateringCartLoading,
    refreshCateringCart,
    editCateringItems,
    removeCateringProvider,
    refundcateringfromcart,
  };
};
